<template>
  <div class="relative">
    <tag-v2 color="mute-01" size="md" class="hint-anchor cursor-pointer">
      {{ anchorLabel }}
      <span class="material-symbols-outlined text-base/[16px] text-[#475569]">
        help
      </span>
    </tag-v2>
    <div
      class="hint-content bg-white absolute top-[calc(100%+4px)] ltr:left-0 rtl:right-0 p-[15px] rounded-[12px] border border-gray-100 shadow-[0_0_6px_#0000001A] z-[100]"
      :style="{ width: `${width}px` }"
    >
      <div
        v-if="title"
        class="text-lg leading-[26px] font-bold text-gray-700 mb-2"
      >
        {{ title }}
      </div>
      <div
        v-if="description"
        class="text-sm leading-5 font-[400] text-gray-500 whitespace-pre-line"
        v-text="description"
      />
      <template v-if="$slots.default">
        <hr class="border-gray-200 my-[19px]" />
        <slot />
      </template>
    </div>
  </div>
</template>

<script>
export default {
  name: 'IntegrationHint',
  props: {
    anchorText: { type: String, default: '' },
    title: { type: String, default: '' },
    description: { type: String, default: '' },
    width: { type: Number, default: 311 },
  },
  computed: {
    anchorLabel() {
      return this.anchorText || this.$t('INTEGRATION_SETTINGS.HINT.ANCHOR');
    },
  },
};
</script>

<style lang="scss" scoped>
.hint-anchor {
  ~ .hint-content {
    @apply hidden;
  }

  &:hover {
    ~ .hint-content {
      @apply block;
    }
  }
}
</style>
